'use es6';

export const EVENTS = {
  PAGEVIEW: 'pageview'
};